export const style = {
  note: {
    fontSize: `12px`,
    margin: `0 5px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Rates/style/paragraphs.js